import React from 'react';
import {} from './Banner.types';
import { Sparkle } from '../Sparkle';
import { clsx } from 'clsx';
const fakeBorderStyle = "before:content-[''] before:absolute before:top-0 before:left-0 before:w-13 before:h-13 before:bg-ai-gradient before:translate-y-[-50%] before:translate-x-[-50%] before:offset-path-ai before:animate-rotate-border ";
const backgroundStyle = "after:top-1 after:left-1 after:right-1 after:bottom-1 after:content-[''] after:bg-ai-background-solid-light after:z-10 after:rounded-md after:absolute";
const bannerWrapperStyle = 'w-full rounded-md overflow-hidden relative bg-ai-background-solid-light';
const bannerStyles = clsx(bannerWrapperStyle, fakeBorderStyle, backgroundStyle);
export const Banner = ({ children }) => {
    return (React.createElement("div", { className: bannerStyles },
        React.createElement("p", { className: "m-0 p-5 flex items-center gap-2 relative z-20 font-medium text-sm" },
            React.createElement(Sparkle, { size: 16 }),
            children)));
};
